
import Preparation from '../teaching-material/preparation/Preparation.vue'
export default {
  components: {
    Preparation
  }
}
